import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import SEOIntroSection from './components/SEOIntroSection';
import FeatureCards from './components/FeatureCards';
import CategorySection from './components/CategorySection';
import ComparisonSection from './components/ComparisonSection';
import { Link } from 'react-router-dom';
import JsonLd from '@/components/base/JsonLd';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hipobuyspread.lat';

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Hipobuy Spreadsheet Guide',
    url: siteUrl,
    description: 'The ultimate product research guide for Hipobuy Spreadsheet. Find organized product information, comparison guides, and safety tips for smarter shopping in 2026.',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteUrl}/?s={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Hipobuy Spreadsheet Guide',
    url: siteUrl,
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg',
    description: 'Independent informational resource providing spreadsheet research guides, product category navigation, and safety education for online shoppers.',
    sameAs: [
      'https://kaspreadsheet.com',
    ],
  };

  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <SEOIntroSection />
        <FeatureCards />

        <section className="py-12 md:py-14 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <div className="bg-gradient-to-r from-primary-100/70 via-accent-100/50 to-primary-100/70 rounded-2xl p-8 md:p-10 border border-primary-200/50">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
                Ready to Start Shopping?
              </h3>
              <p className="text-sm md:text-base text-foreground-600 mb-6">
                Browse thousands of products across all categories on our main website
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  Hipobuy Sheet
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-accent-500 text-background-50 font-semibold text-sm md:text-base hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  Buy It Now
                </a>
              </div>
            </div>
          </div>
        </section>

        <CategorySection />
        <ComparisonSection />

        <section className="py-14 md:py-18 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-5">
                <i className="ri-guide-line text-2xl"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
                New to Hipobuy Spreadsheet?
              </h3>
              <p className="text-sm md:text-base text-foreground-600 mb-6 leading-relaxed">
                Read our comprehensive beginner guide covering everything from basic navigation to advanced product comparison techniques. Learn how to make the most of your spreadsheet research in 2026.
              </p>
              <Link
                to="/hipobuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                Read the Complete Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}